import { createMarkup } from '@finn/auto-ui/utils/html';
import { config, isMobileApp } from '@finn/ui-utils';
import Script from 'next/script';
import React, { useMemo } from 'react';

import { getCurrentUrl } from './metadata';

type Props = {
  appDeepLink?: string;
  jsonLdContent?: string | string[];
};

export const useCurrentUrl = (locale: string, asPath: string) => {
  return useMemo(() => getCurrentUrl(locale, asPath), [asPath, locale]);
};

export const HeadTags = ({ appDeepLink, jsonLdContent }: Props) => {
  const ldContentArr = Array.isArray(jsonLdContent)
    ? jsonLdContent
    : [jsonLdContent];

  return (
    <>
      {appDeepLink && !isMobileApp() ? (
        <Script id="apps_flyer_smart_banner">
          {`!function(t,e,n,s,a,c,i,o,p){t.AppsFlyerSdkObject=a,t.AF=t.AF||function(){(t.AF.q=t.AF.q||[]).push([Date.now()].concat(Array.prototype.slice.call(arguments)))},t.AF.id=t.AF.id||i,t.AF.plugins={},o=e.createElement(n),p=e.getElementsByTagName(n)[0],o.async=1,o.src="https://websdk.appsflyer.com?"+(c.length>0?"st="+c.split(",").sort().join(",")+"&":"")+(i.length>0?"af_id="+i:""),p.parentNode.insertBefore(o,p)}(window,document,"script",0,"AF","banners",{banners: {key: "${config.APPS_FLYER_SMART_BANNER_ID}"}});
        AF('banners', 'showBanner', { additionalParams: { af_dp: '${appDeepLink}', deep_link_value: '${appDeepLink}' }}); `}
        </Script>
      ) : null}
      {jsonLdContent &&
        ldContentArr.map((ld, index) => (
          <script
            data-testid="json-ld"
            key={index}
            type="application/ld+json"
            dangerouslySetInnerHTML={createMarkup(ld || '')}
          />
        ))}
    </>
  );
};

export default HeadTags;
